"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BribedCommittee = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var CardRenderer_1 = require("../render/CardRenderer");
var BribedCommittee = (function (_super) {
    __extends(BribedCommittee, _super);
    function BribedCommittee() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.BRIBED_COMMITTEE,
            tags: [Tags_1.Tags.EARTH],
            cost: 7,
            metadata: {
                cardNumber: '112',
                description: 'Raise your TR 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.tr(2); }),
                victoryPoints: -2,
            },
        }) || this;
    }
    BribedCommittee.prototype.canPlay = function (player) {
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST * 2);
        }
        return true;
    };
    BribedCommittee.prototype.play = function (player) {
        player.increaseTerraformRatingSteps(2);
        return undefined;
    };
    BribedCommittee.prototype.getVictoryPoints = function () {
        return -2;
    };
    return BribedCommittee;
}(Card_1.Card));
exports.BribedCommittee = BribedCommittee;
//# sourceMappingURL=BribedCommittee.js.map